<template>
    <v-layout justify-space-between px-7 py-3 id="headerBar" class="headerBar">
        <v-flex xs6 class="d-flex">
            <span class="white--text my-auto" id="headerText">THE CENTRO CONDO</span>
        </v-flex>

        <v-flex>
            <v-layout justify-end>
                <!-- Language switcher for desktop -->
                <v-flex shrink class="switch-box" v-if="$vuetify.breakpoint.mdAndUp">
                    <span class="switch-lang" :class="{'lang-active':language === 'th'}"
                          @click="langSwitcher('th')">TH</span>
                    <span class="switch-lang" :class="{'lang-active':language === 'en'}"
                          @click="langSwitcher('en')">EN</span>
                    <span class="switch-lang" :class="{'lang-active':language === 'cn'}"
                          @click="langSwitcher('cn')">CN</span>
                </v-flex>
                <!-- Hamburger -->
                <v-flex shrink v-else>
                    <v-btn
                            fab
                            style="box-shadow: unset; background: transparent"
                            @click.stop="drawer = !drawer"
                    >
                        <v-icon large color="#FFF">dehaze</v-icon>
                    </v-btn>

                    <v-navigation-drawer
                            v-model="drawer"
                            absolute
                            height="200vh"
                            style="z-index: 9999; position: fixed; background: #E99B07"
                            class="pa-2"
                            right
                    >
                        <v-layout justify-space-between px-3 pt-3 class="align-items-center">
                            <v-flex shrink>
                                <v-btn
                                        fab @click.stop="drawer = !drawer"
                                        style="box-shadow: unset; background: transparent"
                                >
                                    <v-icon large color="#FFF">dehaze</v-icon>
                                </v-btn>
                            </v-flex>

                            <v-flex shrink class="switch-box">
								<span
                                        class="switch-lang" :class="{'lang-active':language === 'th'}"
                                        @click="langSwitcher('th')">TH</span>
                                <span
                                        class="switch-lang" :class="{'lang-active':language === 'en'}"
                                        @click="langSwitcher('en')">EN</span>
                                <span
                                        class="switch-lang" :class="{'lang-active':language === 'cn'}"
                                        @click="langSwitcher('cn')">CN</span>
                            </v-flex>
                        </v-layout>

                        <v-treeview
                                dark
                                :items="menulist">
                            <template slot="label" slot-scope="props">
                                <a :href="props.item.url" class="white--text text-decoration-none">{{ props.item.name
                                    }}</a>
                            </template>
                        </v-treeview>

                    </v-navigation-drawer>

                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
    import {mapActions, mapState} from "vuex";

    export default {
        name: 'Header',
        props: ['fixed'],
        data: () => ({
            drawer: false,
            timeBarPos: 0,
            menulist: [
                {
                    id: 1,
                    name: 'CONTACT US',
                    url: 'https://www.thecentrocondo.com/'
                }
            ]

        }),
        computed: {
            ...mapState({
                language: state => state.locale.language
            }),
        },
        mounted() {
            this.onScroll();
            // setTimeout(() => {
            //   this.timeBarPos = document.getElementById('head-time').offsetTop;
            // }, 2)
        },
        methods: {
            ...mapActions("locale", ["switchLang"]),
            onScroll() {
                let lastPos = 0;
                let _this = this;
                if (this.fixed) {
                    // fill BG color
                    document.getElementById('headerBar').style.backgroundColor = 'rgba(233, 155, 7, 1)';
                    document.getElementById('headerText').style.opacity = 1;
                } else {
                    window.addEventListener("scroll", () => {
                        if (window.pageYOffset > lastPos) {
                            // hide header when scroll down

                            if (window.pageYOffset > 250) {
                                document.getElementById('headerBar').style.marginTop = '-100px';
                                // fill BG color
                            }
                            if (window.pageYOffset > 500) {
                                // fill BG color
                                document.getElementById('headerBar').style.backgroundColor = 'rgba(233, 155, 7, 1)';
                                document.getElementById('headerText').style.opacity = 1;
                            } else {
                                document.getElementById('headerText').style.opacity = 0;
                            }
                            // lock #head-time position (Home.vue)
                            // if (document.getElementById('head-time').offsetTop <= window.pageYOffset) {
                            //   document.getElementById('head-time').style.position = 'fixed';
                            //   document.getElementById('head-time').style.width = '100%';
                            //   document.getElementById('head-time').style.top = '0';
                            // }
                        }
                        else {
                            // show header when scroll up
                            document.getElementById('headerBar').style.marginTop = '0';
                            if (window.pageYOffset <= 250) {
                                // bg to transparent
                                document.getElementById('headerBar').style.backgroundColor = 'rgba(255, 255, 255, 0)';
                                document.getElementById('headerText').style.opacity = 0;
                            } else {
                                // fill BG color
                                document.getElementById('headerText').style.opacity = 1;
                            }
                            // unlock #head-time position (Home.vue)
                            // if (_this.timeBarPos > window.pageYOffset) {
                            //   document.getElementById('head-time').style.position = 'unset';
                            //   document.getElementById('head-time').style.width = 'unset';
                            //   document.getElementById('head-time').style.top = 'unset';
                            // }
                        }
                        // save last position
                        lastPos = window.pageYOffset <= 0 ? 0 : window.pageYOffset;

                    })
                }
            },
            langSwitcher(lang) {
                this.$i18n.locale = lang
                this.switchLang(lang)
            }
        }
    }

</script>


<style lang="scss" scoped>
    .logo {
        height: 80px;
        width: auto;
    }

    .headerBar {
        width: 100%;
        position: fixed;
        z-index: 100;
    }

    #headerBar {
        transition: all .2s linear;
        #headerText {
            opacity: 0;
        }
    }

    .switch-box {
        padding: 7px 0;
        border: solid 1px #FFF;
        border-radius: 30px;
    }

    .switch-lang {
        border-radius: 30px;
        padding: 7px 10px;
        cursor: pointer;
        user-select: none;
        color: #FFF;
    }

    .lang-active {
        background: #FFF;
        color: #936800;
    }

    .v-select {
        width: 180px;
    }

    .btn-header {
        color: #FFF;
        box-shadow: unset;
        font-size: 16px !important;
        letter-spacing: .5px;
        margin: 0 13px;
    }

</style>
